import fetch from "axios";
import * as user from "./user";
import * as notice from "./notice";
import * as school from "./school";

export default {
    user,
    notice,
    school,
    fetch
};
